import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { UncontrolledTooltip, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import i18n from "../../i18n";
import { ServiceStatus, Permissions, BookingType } from "../../constants/enums";
import NotesServiceModal from "./NotesServiceModal";
import FinishServiceModal from "./FinishServiceModal";
import ReferenceServiceModal from "./ReferenceServiceModal";

const CardService = ({ service, infoUser, setSelectedService, typeService, setRequestServiceCancelModal, clickAssignService, onClickAssignService }) => {

  const location = useLocation();
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [isNoteValid, setIsNoteValid] = useState(false);
  const [finishServiceModalOpen, setFinishServiceModalOpen] = useState(false);
  const [referenceServiceModalOpen, setReferenceServiceModalOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleNotesModal = () => setNotesModalOpen(!notesModalOpen);
  const toggleFinishServiceModal = () => setFinishServiceModalOpen(!finishServiceModalOpen);
  const toggleReferenceServiceModal = () => setReferenceServiceModalOpen(!referenceServiceModalOpen);

  const onClickDelete = (service) => {
    setSelectedService(service);
    setRequestServiceCancelModal(true);
  };

  const onClickEdit = (service) => {
    setSelectedService(service);
    navigate(`/services/request/edit/${service.code}`);
  };

  const onClickReassign = (service) => {
    setSelectedService(service);

    const storedServices = JSON.parse(localStorage.getItem("services")) || [];
    const updatedServices = [...storedServices, service];
    localStorage.setItem("services", JSON.stringify(updatedServices));

    navigate(`/services/reassignment/${service.code}`);
  };

  const getRoute = () => {
    const basePath = location.pathname.includes('/services/reservations') || 
                     location.pathname.includes('/services/assignment') ||
                     location.pathname.includes('/services/historical')
      ? '/services/reservations'
      : '/services/request';
      
    return `${basePath}/${service.code}`;
  };

  return (
    <Fragment>
      <tr key={service.code}>
        {clickAssignService && (
          <td>
            <Input
              type="checkbox"
              id={`check-${service.code}`}
              className="checksServices"
              name="checksEmployees"
              onClick={(e) => onClickAssignService(service, "one", e)}
            />
          </td>
        )}
        <td>{service.partner_name}</td>
        <td>{service.code}</td>
        {service.status.key !== ServiceStatus.UNASSIGNED && <td>{service.plate}</td>}
        <td className="fs-10">
          {service.origin.status === "DEFINED" ? service?.origin?.address?.description : ""}
        </td>
        <td className="fs-10">
          {service.destination.status === "DEFINED" ? service?.destination?.address?.description : ""}
        </td>
        <td>{service.scheduled_start.date}</td>
        <td>{`${service.scheduled_start.time} ${service.scheduled_start.period}`}</td>
        <td>
          {service.type.key === BookingType.OPEN
            ? i18n.t("OpenServices")
            : service.type.key === BookingType.CLOSED
            ? i18n.t("ClosedServices")
            : i18n.t(service.type.key)
          }
        </td>
        <td>{service.place || ""}</td>
        <td>
          <p className={`bg-${service.status.key.toLowerCase()} text-white rounded-2 text-center p-1 fs-10`}>
            {`${service.status.value}`}
          </p>
        </td>
        <td className="d-flex">
          <Link
            to={getRoute()}
            onClick={() => localStorage.setItem('typeService', typeService)}
            className="btn btn-soft-primary waves-effect waves-light btn btn-secondary mx-1 align-content-center"
          >
            <i className="fas fa-eye" />
          </Link>
          {service.status.key !== ServiceStatus.ASSIGNED && (
            <button
              className="btn btn-edit waves-effect waves-light mx-1 edit-button"
              onClick={() => onClickEdit(service)}
              id={`edittooltip-${service.code}`}
              disabled={[ServiceStatus.STARTED, ServiceStatus.FINISHED, ServiceStatus.DELETED].includes(service.status.key)}
            >
            <i className="mdi mdi-pencil font-size-18 edit-icon"></i>
              <UncontrolledTooltip placement="top" target={`edittooltip-${service.code}`}>
                {i18n.t("Edit")}
              </UncontrolledTooltip>
            </button>                
          )}
          {[ServiceStatus.ASSIGNED].includes(service.status.key) &&
            infoUser.permissions.includes(Permissions.UNASSIGN_SERVICES) && (
              <button
                className="btn btn-edit waves-effect waves-light mx-1 edit-button"
                onClick={() => onClickReassign(service)}
                id={`edittooltip-${service.code}`}
              >
              <i className="mdi mdi-pencil font-size-18 edit-icon"></i>
                <UncontrolledTooltip placement="top" target={`edittooltip-${service.code}`}>
                  {i18n.t("Edit")}
                </UncontrolledTooltip>
              </button>                
            )
          }
            <button
              className="btn btn-deleted-request waves-effect waves-light mx-1"
              onClick={() => onClickDelete(service)}
              id={`deletetooltip-${service.code}`}
              disabled={![ServiceStatus.UNASSIGNED, ServiceStatus.ASSIGNED, ServiceStatus.REJECTED].includes(service.status.key)}
            >
              <i className="mdi mdi-delete font-size-18 deleted-icon" />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${service.code}`}>
                {i18n.t("Cancel")}
              </UncontrolledTooltip>
            </button>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} direction="left">
              <DropdownToggle
                className="btn btn-more-actions waves-effect waves-light btn btn-secondary mx-1"
                tag="button"
                id={`moreactionstooltip-${service.code}`}
                disabled={[ServiceStatus.STARTED, ServiceStatus.FINISHED].includes(service.status.key)}
              >
                <i className="mdi mdi-dots-vertical font-size-18 more-actions-icon" />
              </DropdownToggle>
              <UncontrolledTooltip placement="top" target={`moreactionstooltip-${service.code}`}>
                {i18n.t("MoreActions")}
              </UncontrolledTooltip>
              <DropdownMenu>
                <DropdownItem onClick={toggleNotesModal}>
                  {i18n.t("Notes")}
                </DropdownItem>
                {service.status.key === ServiceStatus.ASSIGNED && infoUser.is_staff && (
                  <DropdownItem onClick={toggleFinishServiceModal}>
                    {i18n.t("EndWithoutPassenger")}
                  </DropdownItem>
                )}
                {service.status.key === ServiceStatus.ASSIGNED && infoUser.is_staff && (
                  <DropdownItem onClick={toggleReferenceServiceModal}>
                    {i18n.t("EditReferenceNote")}
                  </DropdownItem>
                )}
                {service.status.key === ServiceStatus.UNASSIGNED && (
                  <DropdownItem
                    onClick={() => {
                      sessionStorage.setItem("rescheduleServiceCode", service.code);
                      navigate("/services/request/reschedule");
                    }}
                  >
                    {i18n.t("Reschedule")}
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
        </td>
      </tr>
      <NotesServiceModal
        isOpen={notesModalOpen}
        toggle={toggleNotesModal}
        selectedService={service}
        setIsNoteValid={setIsNoteValid}
      />
      <FinishServiceModal
        isOpen={finishServiceModalOpen}
        toggle={toggleFinishServiceModal}
        selectedService={service}
      />
      <ReferenceServiceModal
        isOpen={referenceServiceModalOpen}
        toggle={toggleReferenceServiceModal}
        selectedService={service}
      />
    </Fragment>
  );
};

CardService.propTypes = {
  service: PropTypes.object.isRequired,
};

export default CardService;
